import { styled, keyframes } from '@acko-tech/building-blocks.ui.common';

import Typography from 'Components/common/typography';

import { APP_CONTENT_MAX_WIDTH } from 'Constants/common';

interface IStageDetailsBoxProps {
    isCurrentStage?: boolean;
    stageCompleted?: boolean;
    isSubStage?: boolean;
    hideBar?: boolean;
    hideArrow?: boolean;
    isServiceClosed?: boolean;
    isNextStageClosed?: boolean;
    boxIndex?: number;
}

const TIMELINE_ANIMATION_DELAY = 0.8;

const slideUp = keyframes`
    0% {
        transform: translateY(20px);
        opacity: 0;
    }
    100% {
        transform: translateY(0px);
        opacity: 1;
    }
`;

export const TimelineWrapper = styled.div<{ stageHasActions: boolean }>`
    max-width: ${APP_CONTENT_MAX_WIDTH};
    margin: 20px auto;
    opacity: 0;
    animation: ${slideUp} 0.4s
        ${(props: any) => (props.stageHasActions ? '0.6s' : '0.5s')} forwards;

    // @media (max-width: 700px) {
    //     padding: 0 20px;
    // }
`;

export const Title = styled(Typography)`
    margin: 20px 0;
`;

export const StageDetailsBox = styled.div<IStageDetailsBoxProps>`
    position: relative;
    padding: 0 0 0 40px;
    margin: 5px 0;

    &::before {
        content: '';
        position: absolute;
        height: 18px;
        width: 18px;
        background: ${(props: any) =>
            props.stageCompleted
                ? (props?.isServiceClosed && '#D83D37') || '#0FA457'
                : '#fff'};
        border: 2px solid
            ${(props: any) =>
                (props?.isServiceClosed &&
                    (props.stageCompleted || props.isCurrentStage
                        ? '#D83D37'
                        : '#FBEAEA')) ||
                (props.stageCompleted || props.isCurrentStage
                    ? '#0FA457'
                    : '#CBCBDB')};
        left: 0;
        top: 0;
        border-radius: 50%;
        z-index: 1;
    }

    &::after {
        position: absolute;
        height: 0;
        width: 1px;
        border-left: 2px
            ${(props: any) =>
                props.stageCompleted
                    ? `solid ${
                          props?.isServiceClosed || props?.isNextStageClosed
                              ? '#FBEAEA'
                              : '#0FA457'
                      }`
                    : `dashed ${
                          props?.isServiceClosed || props?.isNextStageClosed
                              ? '#FBEAEA'
                              : '#CBCBDB'
                      }`};
        left: 10px;
        top: 20px;
        animation: expandLine ${TIMELINE_ANIMATION_DELAY}s linear
            ${(props: any) => props.boxIndex * TIMELINE_ANIMATION_DELAY}s
            forwards;
    }

    &:not(&:nth-last-of-type(1)) {
        &::after {
            content: '';
        }
    }

    & > div:first-child {
        &::after {
            content: ${(props: any) =>
                props.isSubStage || props.hideArrow ? '' : '""'};
        }
        &::before {
            content: ${(props: any) => (props.stageCompleted ? '""' : '')};
            animation: ${(props: any) => (props.stageCompleted ? 'bump' : '')}
                0.5s linear
                ${(props: any) => props.boxIndex * TIMELINE_ANIMATION_DELAY}s
                forwards;
        }
    }

    ${(props: any) => props.hideBar && `&::after { content: '' }`};

    @keyframes expandLine {
        0% {
            height: 0;
        }
        100% {
            height: 100%;
        }
    }

    @keyframes bump {
        0% {
            transform: scale(0.6) rotate(40deg);
        }
        50% {
            transform: scale(1.4) rotate(40deg);
        }
        100% {
            transform: scale(1) rotate(40deg);
        }
    }
`;

export const StageTitle = styled.div<{
    showLinkArrow?: boolean;
    noStatus: boolean;
}>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    & > div {
        color: ${(props: any) => (props.noStatus ? '#5B5675' : '#040222')};
        font-size: 14px;
        line-height: 20px;
        color: #040222;
        font-weight: 500;
        width: 80%;
    }
    ${(props: any) =>
        props.showLinkArrow &&
        `
            cursor: pointer;
            &::after {
                position: absolute;
                right: 0;
                top: 5px;
                height: 8px;
                width: 8px;
                border-right: 2px solid #040222;
                border-bottom: 2px solid #040222;
                transform: rotate(-45deg);
                cursor: pointer;
            }
        `}

    &::before {
        position: absolute;
        left: -32px;
        top: 5px;
        height: 8px;
        width: 4px;
        border-right: 2px solid #fff;
        border-bottom: 2px solid #fff;
        cursor: pointer;
        z-index: 2;
        transform: scale(0) rotate(40deg);
    }
`;

export const StageCompletedTime = styled(Typography)<{ showInfo: boolean }>`
    font-size: 12px;
    color: #5b5675;
    padding: 6px 0 16px;
    border-bottom: 1px solid
        ${(props: any) => (!props.showInfo ? '#E7E7F0' : '#fff')};
`;

export const SurveyInfoCard = styled.div<{ isSubStage: boolean }>`
    display: grid;
    grid-template-columns: 30px 1fr;
    justify-content: center;
    align-items: center;
    grid-gap: 10px;
    border-radius: 8px;
    width: 100%;
    min-height: 60px;
    background: #fff7e5;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    padding: 10px 20px;
    margin: 0 0 ${(props: any) => props.isSubStage && '0 40px'};
`;

export const ActiveText = styled.span`
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    color: #0fa457;
    font-weight: 600;
    position: absolute;
    right: 0;
`;
